
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import ArtistImage from "./ArtistImage.vue";
import {store} from "../Store";

@Component({
    components: {ArtistImage}
})
export default class ArtistList extends Vue {
    data = store.data;
}
